import { useEffect } from "react";
 import { ReactComponent as PopUpDesign } from "../../assets/img/transactionPopupDesign.svg";
import { AmountStep, SummaryStep } from "./RenderSteps";
import SuccessStep from "./SuccessStep";
import "./BuyPowerWorkFlow.scss";
import InvoiceStep from "./InvoiceStep";
import { usePowerPurchaseStore } from "../../store/buyPowerStore";
 
 
interface BuyPowerFlowProps {
  meterNumber: string;
  meterName: string;
  address: string;
  phoneNumber: string;
  onClose: () => void;
  onPaymentSuccess: () => void;
  onPaymentError: () => void;
  isAdmin?: boolean;
}

const BuyPowerFlow: React.FC<BuyPowerFlowProps> = ({
  meterNumber,
  meterName,
  address,
  phoneNumber,
  onClose,
  onPaymentSuccess,
  onPaymentError,
  isAdmin

}) => {
  const { step, resetFlow } = usePowerPurchaseStore();
   

  useEffect(() => {
    // Initialize meter details when flow starts
    usePowerPurchaseStore.setState({
      meterDetails: {
        meterNumber,
        meterName,
        address,
        phoneNumber
      }
    });

    // Cleanup on unmount
    return () => {
      resetFlow();
    };
  }, [meterNumber, meterName, address, phoneNumber, resetFlow]);

  const renderStep = () => {
    switch (step) {
      case 'amount':
        return <AmountStep  />;
      case 'summary':
        return <SummaryStep onClose={onClose} onPaymentSuccess={onPaymentSuccess} onPaymentError={onPaymentError} />;
      case 'invoice':
        return <InvoiceStep  onClose={onClose} onPaymentSuccess={onPaymentSuccess} onPaymentError={onPaymentError} />;
        
      case 'success':
        return <SuccessStep onClose={onClose} />;
      default:
        return <AmountStep />;
    }
  };

  return (
    <div className="w-full  relative z-10 buy-power-flow">
      {/* Decorative circuit pattern at top */}
      <div className="w-fit flex -mt-5 mx-auto">
        <PopUpDesign />
      </div>

      {/* Step Content */}
      {renderStep()}
    </div>
  );
};

export default BuyPowerFlow;